import { CircularProgress } from '@mui/material';
import Popover from '@mui/material/Popover';
import Button from 'components/button/Button';
import Parser, { domToReact } from 'html-react-parser';
import moment from 'moment';
import React, { useCallback, useState } from 'react';
import InfiniteScroll from 'react-infinite-scroll-component';
import { useHistory, useLocation } from "react-router";
import { Link } from "react-router-dom";
import LogoSm from "../../assets/icons/logo-sm.png";
import { ReactComponent as NotificationsIcon } from '../../assets/icons/notification.svg';
import { NotificationActionsPrimaryBtn, NotificationActionsSecondaryBtn, NotificationAvatar, NotificationAvatarImage, NotificationButton, NotificationButtonIcon, NotificationContainer, NotificationContent, NotificationContentAddedBy, NotificationContentDate, NotificationContentInfo, NotificationContentName, NotificationHeder, NotificationItem, NotificationList, NotificationLoading, NotificationsTotalBadge } from './Theme';
const DynamicHtmlComponent = (htmlContent) => {
  return (
    <div>
      {htmlContent && (
        <div>
          {Parser(htmlContent, {
            replace: ({ name, attribs, children }) => {
              if (name === "a" && attribs && attribs.href && attribs.href.startsWith("/")) {
                return (
                  <Link to={attribs.href} onClick={(e) => e.stopPropagation()}>
                    {children.map((child, index) => (
                      <React.Fragment key={index}>{child.data}</React.Fragment>
                    ))}
                  </Link>
                );
              }
            },
          })}
        </div>
      )}
    </div>
  );
};

const LinkReplacer = (htmlContent) => {
  const history = useHistory();
  const { pathname } = useLocation();

  const replaceLinks = (domNode) => {
    if (domNode && domNode.type === 'tag' && domNode.name === 'a' && domNode.attribs) {
      const { href } = domNode.attribs;
      const currentBaseUrl = window.location.origin;
      const internalLink = href.startsWith("/") || href.startsWith(currentBaseUrl);
      if (internalLink) {
        return (
          <Link to={href} onClick={(e) => {
            e.stopPropagation();
          }}>
            {domToReact(domNode.children, { replace: replaceLinks })}
          </Link>
        );
      } else {
        return (
          <a href={href} target="_blank" rel="noopener noreferrer">
            {domToReact(domNode.children, { replace: replaceLinks })}
          </a>
        );
      }
    }
  };
  if (typeof htmlContent !== 'string') {
    return null;
  }
  const parsedContent = Parser(htmlContent, { replace: replaceLinks });

  return <>{parsedContent}</>;
};




const Notifications = ({ notifications, isLoading, markAsRead, markAllAsRead, fetchMoreNotifications, hasMore, openAddNotify, totalNotifications }) => {

  const { push } = useHistory();
  const [anchorEl, setAnchorEl] = useState(null);


  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? 'simple-popover' : undefined;


  const checkIfAnyNotificationsNotRead = useCallback(() => {
    const notReadNotifications = notifications.filter(notification => !notification.read);
    return notReadNotifications.length > 0;
  }, [notifications]);


  const markAsReadHandler = useCallback((notification) => {
    markAsRead(notification);
  }, [markAsRead]);

  const openAddNotifyHandler = () => {
    openAddNotify();
    handleClose();
  }


  const displayProfileImage = (item) => {
    return item?.type === "manual" ? item?.createdBy?.contactId?.profile_img || LogoSm : LogoSm;
  }

  const displayAddedBy = (item) => {
    return item?.type === "manual" ? item?.createdBy?.name : "System";
  }


  return (
    <>
      <NotificationButton aria-describedby={id} variant="contained" onClick={handleClick}>
        <NotificationButtonIcon showIndicator={checkIfAnyNotificationsNotRead()}>
          <NotificationsIcon />
          {totalNotifications > 0 && <NotificationsTotalBadge>{totalNotifications > 99 ? "99+" : totalNotifications}</NotificationsTotalBadge>}
        </NotificationButtonIcon>
      </NotificationButton>
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
        sx={{
          top: "8px",
        }}
      >
        <NotificationContainer>
          {isLoading ? (
            <NotificationLoading>
              <CircularProgress />
            </NotificationLoading>
          ) : (
            <>
              <NotificationHeder>
                <Button
                  onClick={markAllAsRead}
                  variant="primary-outline"
                  size="md"
                  style={{ fontWeight: 500 }}
                  disabled={totalNotifications === 0}
                >
                  <span>Mark all as read</span>
                </Button>
                <Button
                  onClick={openAddNotifyHandler}
                  variant="primary"
                  size="md"
                  style={{ fontWeight: 500 }}
                >
                  <span>Notify</span>
                </Button>
              </NotificationHeder>
              <InfiniteScroll
                className="notification-scroll"
                dataLength={notifications?.length}
                next={fetchMoreNotifications}
                hasMore={hasMore} 
                loader={
                  <div className="w-100 d-flex justify-content-center align-items-center" style={{ height: '100px' }}>
                    <CircularProgress />
                  </div>
                }
                height={600}
              >
                <NotificationList>
                  {notifications?.map((item, id) => (
                    <NotificationItem key={id} read={item?.read} onClick={() => markAsReadHandler(item)}>
                      <NotificationAvatar showIndicator={!item?.read}>
                        <NotificationAvatarImage src={displayProfileImage(item)} />
                      </NotificationAvatar>
                      <NotificationContent>
                        <NotificationContentInfo>
                          {LinkReplacer(item?.message)}
                        </NotificationContentInfo>
                        <NotificationContentAddedBy>
                          Added by <NotificationContentName>{displayAddedBy(item)}</NotificationContentName> {moment(item.createdAt).fromNow()}
                        </NotificationContentAddedBy>
                      </NotificationContent>
                    </NotificationItem>
                  ))}
                </NotificationList>
              </InfiniteScroll>
            </>
          )}
        </NotificationContainer>
      </Popover>
    </>
  )
}

export default Notifications